import React from 'react';

import { LessonPreviewLayout } from 'components/Layout';
import { PluginPreviewPage } from './components/PluginPreviewPage';
import { WebPreviewPage } from './components/WebPreviewPage';

const QuizPreviewPage = ({
  correct,
  submitted,
  questions,
  currentAnswers,
  currentQuestion,
  onQuestionsSwiper,
  onAnswerClick,
  onNextQuestionClick,
  onTryAgainClick,
  onCheckClick,
  onRestartLessonClick,
  previewType,
  setPreviewType,
  isTestMode,
  setTestMode,
  onChangePreviewType,
  ...props
}: {
  correct: any;
  submitted: any;
  questions: any;
  currentAnswers: any;
  currentQuestion: any;
  onQuestionsSwiper: any;
  onAnswerClick: any;
  onNextQuestionClick: any;
  onTryAgainClick: any;
  onCheckClick: any;
  onRestartLessonClick: any;
  previewType: any;
  setPreviewType: any;
  isTestMode: any;
  setTestMode: any;
  onChangePreviewType: any;
  props: any;
}) => {
  return (
    <LessonPreviewLayout
      setPreviewType={onChangePreviewType}
      setTestMode={setTestMode}
    >
      {previewType === 'Plugin' ? (
        <PluginPreviewPage
          {...props}
          correct={correct}
          submitted={submitted}
          questions={questions}
          currentQuestion={currentQuestion}
          currentAnswers={currentAnswers}
          onQuestionsSwiper={onQuestionsSwiper}
          onCheckClick={onCheckClick}
          onAnswerClick={onAnswerClick}
          onTryAgainClick={onTryAgainClick}
          onNextQuestionClick={onNextQuestionClick}
          onRestartLessonClick={onRestartLessonClick}
          previewType={previewType}
          isTestMode={isTestMode}
        />
      ) : (
        <WebPreviewPage
          {...props}
          correct={correct}
          submitted={submitted}
          questions={questions}
          currentQuestion={currentQuestion}
          currentAnswers={currentAnswers}
          onQuestionsSwiper={onQuestionsSwiper}
          onCheckClick={onCheckClick}
          onAnswerClick={onAnswerClick}
          onTryAgainClick={onTryAgainClick}
          onNextQuestionClick={onNextQuestionClick}
          onRestartLessonClick={onRestartLessonClick}
          isTestMode={isTestMode}
        />
      )}
    </LessonPreviewLayout>
  );
};

export default React.memo(QuizPreviewPage) as any;
